import { PositiveTextFilterType } from '../../../../../types';

export const enum UniversalFilterTaskItemsModes {
  CONTAINS_ALL_OF = 'contains_all_of'
}

export type UniversalFilterTaskItemsValue = PositiveTextFilterType;

export type UniversalFilterTaskItemsFilterState = {
  mode: UniversalFilterTaskItemsModes;
  itemNames?: string[];
};

export type UniversalFilterTaskItemsOnFilterStateChange = (
  state: UniversalFilterTaskItemsFilterState
) => void;

export type UniversalFilterTaskItemsOnChange = (
  value?: UniversalFilterTaskItemsValue
) => void;
